import {
    CREATE_PROCESS_COST_PER_KG_REQUEST,
    CREATE_PROCESS_COST_PER_KG_SUCCESS,
    CREATE_PROCESS_COST_PER_KG_FAILURE,
    DELETE_PROCESS_COST_PER_KG_REQUEST,
    DELETE_PROCESS_COST_PER_KG_SUCCESS,
    DELETE_PROCESS_COST_PER_KG_FAILURE,
    FETCH_SINGLE_PROCESS_COST_PER_KG_REQUEST,
    FETCH_SINGLE_PROCESS_COST_PER_KG_SUCCESS,
    FETCH_SINGLE_PROCESS_COST_PER_KG_FAILURE,
    FETCH_PROCESS_COST_PER_KG_REQUEST,
    FETCH_PROCESS_COST_PER_KG_SUCCESS,
    FETCH_PROCESS_COST_PER_KG_FAILURE,
    UPDATE_PROCESS_COST_PER_KG_REQUEST,
    UPDATE_PROCESS_COST_PER_KG_SUCCESS,
    UPDATE_PROCESS_COST_PER_KG_FAILURE,
    RESET_PROCESS_COST_PER_KG_INFO,
    CREATE_PROCESS_COST_PER_KG_FORM,
    UPDATE_PROCESS_COST_PER_KG_FORM,
    FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_FAILURE,
    ASSIGN_PROCESS_TOGGLE_KG,
    FETCH_CHECK_COST_BY_PROCESS_ID_REQUEST,
    FETCH_CHECK_COST_BY_PROCESS_ID_SUCCESS,
    FETCH_CHECK_COST_BY_PROCESS_ID_FAILURE,
    FETCH_INSERT_COST_BY_PROCESS_ID_REQUEST,
    FETCH_INSERT_COST_BY_PROCESS_ID_SUCCESS,
    FETCH_INSERT_COST_BY_PROCESS_ID_FAILURE,
    CHECK_INSERT_COST_BY_PROCESS_ID_REQUEST,
    CHECK_INSERT_COST_BY_PROCESS_ID_SUCCESS,
    CHECK_INSERT_COST_BY_PROCESS_ID_FAILURE,
    SET_SELECT_PROCESS_VALUE,
    FETCH_DELETE_BY_PROCESS_ID_REQUEST,
    FETCH_DELETE_BY_PROCESS_ID_SUCCESS,
    FETCH_DELETE_BY_PROCESS_ID_FAILURE,
    FETCH_PROCESS_COST_PER_KG_INVOICE_REQUEST,
    FETCH_PROCESS_COST_PER_KG_INVOICE_SUCCESS,
    FETCH_PROCESS_COST_PER_KG_INVOICE_FAILURE,
    RESET_PROCESS_COST_PER_KG_INVOICE,
    FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_REQUEST,
    FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_SUCCESS,
    FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_FAILURE,
    FETCH_PROCESS_FLOW_PER_KG_REQUEST,
    FETCH_PROCESS_FLOW_PER_KG_SUCCESS,
    FETCH_PROCESS_FLOW_PER_KG_FAILURE,
    FETCH_INSERT_COST_BY_PROCESS_ID2_REQUEST,
    FETCH_INSERT_COST_BY_PROCESS_ID2_SUCCESS,
    FETCH_INSERT_COST_BY_PROCESS_ID2_FAILURE,
    PREVLIST_LOADER_INDICATION,
    PREVLIST_LOADER_INDICATION_STYLE,
    FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_RESET,
    FETCH_CHECK_PROCESS_REQUEST,
    FETCH_CHECK_PROCESS_FAILURE,
    FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_SUCCESS
} from './processCostPerKg.actionsType';

export const PROCESS_COST_PER_KG = 'processCostPerKg';

let initialState = {
    loading: false,
    processCostPerKgList: [],
    processCostPerKgListByStyle: [],
    processCostPerKgForm: {},
    checkProcessIdData: [],
    processFlowList: [],
    selectedState: {},
    errorMessage: '',
    responseStatusCostPerKg: '',
    assignProcessModal: false,
    selectProcessId: '',
    processcostperkgInvoice: [],
    previousGetLoader: true

};

export let processCostPerKgReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;



    switch (type) {
        case FETCH_PROCESS_COST_PER_KG_REQUEST:
        case CREATE_PROCESS_COST_PER_KG_REQUEST:
        case UPDATE_PROCESS_COST_PER_KG_REQUEST:
        case FETCH_SINGLE_PROCESS_COST_PER_KG_REQUEST:
        case FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_REQUEST:
        case FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_REQUEST:
        case DELETE_PROCESS_COST_PER_KG_REQUEST:
        case FETCH_CHECK_COST_BY_PROCESS_ID_REQUEST:
        case FETCH_INSERT_COST_BY_PROCESS_ID_REQUEST:
        case CHECK_INSERT_COST_BY_PROCESS_ID_REQUEST:
        case FETCH_DELETE_BY_PROCESS_ID_REQUEST:
        case FETCH_PROCESS_COST_PER_KG_INVOICE_REQUEST:
        case FETCH_PROCESS_FLOW_PER_KG_REQUEST:
        case FETCH_INSERT_COST_BY_PROCESS_ID2_REQUEST:
        case FETCH_CHECK_PROCESS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_COST_PER_KG_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgList: updatePayload,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                }
            };
        case FETCH_PROCESS_FLOW_PER_KG_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowList: updatePayload
            };
        case FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricAuthData: updatePayload || []
            }
        case FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgListByStyle: updatePayload
            };
        case PREVLIST_LOADER_INDICATION_STYLE: {
            return {
                ...state,
                loading: false,
                previousGetLoader: payload
            }
        }
        case CREATE_PROCESS_COST_PER_KG_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                }
            };
        case UPDATE_PROCESS_COST_PER_KG_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                },
                responseStatusCostPerKg: updatePayload
            };
        case FETCH_CHECK_COST_BY_PROCESS_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                checkProcessIdData: updatePayload
            };
        case FETCH_INSERT_COST_BY_PROCESS_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                }
            };
        case FETCH_INSERT_COST_BY_PROCESS_ID2_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                }
            };
        case FETCH_DELETE_BY_PROCESS_ID_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case CHECK_INSERT_COST_BY_PROCESS_ID_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_SINGLE_PROCESS_COST_PER_KG_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    fldId: updatePayload[0].FldCombineID,
                    fldFKProcessFlow: updatePayload[0].FldFKProcessFlow,
                    fldWeight: updatePayload[0].FldWeight,
                    fldCost: updatePayload[0].FldCost,
                    fldFKStyle: updatePayload[0].FldFKStyle,
                    FldIsVerified: updatePayload[0].FldIsVerified
                }
            };
        case DELETE_PROCESS_COST_PER_KG_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                },
                deleteErrorMessage: updatePayload !== 200 ? updatePayload : '',
            };
        case FETCH_PROCESS_COST_PER_KG_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                processcostperkgInvoice: updatePayload
            };
        case RESET_PROCESS_COST_PER_KG_INVOICE:
            return {
                ...state,
                processcostperkgInvoice: []
            };
        case RESET_PROCESS_COST_PER_KG_INFO:
            return {
                ...state,
                processCostPerKgForm: {
                    showPartColor: state.processCostPerKgForm?.showPartColor
                }
            };
        case CREATE_PROCESS_COST_PER_KG_FORM:
        case UPDATE_PROCESS_COST_PER_KG_FORM:
            return {
                ...state,
                loading: false,
                processCostPerKgForm: {
                    ...state.processCostPerKgForm,
                    [payload.key]: payload.value
                }
            };
        case UPDATE_PROCESS_COST_PER_KG_FAILURE:
            return {
                ...state,
                loading: false,
                responseStatusCostPerKg: updatePayload?.status
            };
        case FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                processCostPerKgListByStyle: [],
                ...state,
                loading: false
            };


        case FETCH_PROCESS_COST_PER_KG_FAILURE:
        case FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_FAILURE:
        case CREATE_PROCESS_COST_PER_KG_FAILURE:
        case FETCH_SINGLE_PROCESS_COST_PER_KG_FAILURE:
        case DELETE_PROCESS_COST_PER_KG_FAILURE:
        case FETCH_CHECK_COST_BY_PROCESS_ID_FAILURE:
        case FETCH_INSERT_COST_BY_PROCESS_ID_FAILURE:
        case CHECK_INSERT_COST_BY_PROCESS_ID_FAILURE:
        case FETCH_DELETE_BY_PROCESS_ID_FAILURE:
        case FETCH_PROCESS_COST_PER_KG_INVOICE_FAILURE:
        case FETCH_PROCESS_FLOW_PER_KG_FAILURE:
        case FETCH_INSERT_COST_BY_PROCESS_ID2_FAILURE:
        case FETCH_CHECK_PROCESS_FAILURE:
            return {
                ...state,
                loading: false
            };
        case ASSIGN_PROCESS_TOGGLE_KG:
            return {
                ...state,
                assignProcessModal: payload
            };
        case SET_SELECT_PROCESS_VALUE:
            return {
                ...state,
                selectProcessId: payload
            };
        default:
            return state;
    }
};
